export const getSeekId = () => {
  if (typeof window !== 'undefined') {
    const localStorageIsAvailable = window && window.localStorage;
    return localStorageIsAvailable
      ? window.localStorage.getItem('adv-account-selection-seek-id')
      : '99999999';
  }
};

export const getAccountId = () => {
  if (typeof window !== 'undefined') {
    const localStorageIsAvailable = window && window.localStorage;
    return localStorageIsAvailable
      ? window.localStorage.getItem('adv-account-selection-billing-id')
      : '99999999';
  }
};
